import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import StateField, { usStatePropType } from './StateField';
import { required } from '../../Helpers/validators';
import { samplePolicyFormName } from '../../Constants/constants';
import { apiUrl } from '../../Constants/constants';

const SamplePolicyDocument = ({ usStates }) => {
  const renterState = useSelector(
    (state) => state.form[samplePolicyFormName]?.values?.renterState,
  );

  return (
    <>
      <div>
        <div className="row mr-0">
          <div className="col-lg-8 my-5">
            <div className="card samplePolicy__card">
              <div className="card-body">
                <h5 className="samplePolicy__content">
                  Insured residence location
                </h5>

                <Field
                  component={StateField}
                  validate={[required]}
                  name="renterState"
                  type="select"
                  usStates={usStates}
                />

                {renterState && (
                  <>
                    <hr className="samplePolicy__border" />
                    <h5 className="my-2 samplePolicy__content">
                      View or download policy form
                    </h5>
                    <a
                      href={`${apiUrl}sample-policy-documents/${renterState}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="d-flex">
                        <div>
                          <i className="far fa-file-pdf" />
                        </div>
                        <div className="ml-2 samplePolicy__link">
                          Basic Coverage Specimen GatherGuard Event Insurance
                          Policy
                        </div>
                      </div>
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

SamplePolicyDocument.propTypes = {
  usStates: usStatePropType.isRequired,
};

export default SamplePolicyDocument;
